var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3651_17297)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0004 0.614746C15.8189 0.614746 18.1115 2.90736 18.1115 5.72668V11.8434C18.1115 14.6619 15.8189 16.9553 13.0004 16.9553H5.63341C2.81495 16.9553 0.521484 14.6619 0.521484 11.8434V5.72668C0.521484 2.90736 2.81495 0.614746 5.63341 0.614746H13.0004ZM13.0004 1.89315H5.63341C3.51978 1.89315 1.7999 3.61304 1.7999 5.72668V11.8434C1.7999 13.9571 3.51978 15.6769 5.63341 15.6769H13.0004C15.1141 15.6769 16.8331 13.9571 16.8331 11.8434V11.6048L14.0224 11.6053C12.4057 11.6053 11.0897 10.2903 11.0889 8.67436C11.0889 7.05674 12.4048 5.74082 14.0224 5.73997L16.8331 5.73946V5.72668C16.8331 3.61304 15.1141 1.89315 13.0004 1.89315ZM16.8331 7.01787L14.0224 7.01838C13.1097 7.01923 12.3673 7.76157 12.3673 8.67346C12.3673 9.58458 13.1105 10.3269 14.0224 10.3269L16.8331 10.3264V7.01787ZM14.4124 7.98145C14.7652 7.98145 15.0516 8.26782 15.0516 8.62068C15.0516 8.97348 14.7652 9.25985 14.4124 9.25985H14.1465C13.7937 9.25985 13.5073 8.97348 13.5073 8.62068C13.5073 8.26782 13.7937 7.98145 14.1465 7.98145H14.4124ZM9.62805 4.48244C9.98085 4.48244 10.2672 4.76881 10.2672 5.12165C10.2672 5.47449 9.98085 5.76085 9.62805 5.76085H5.0266C4.67376 5.76085 4.3874 5.47449 4.3874 5.12165C4.3874 4.76881 4.67376 4.48244 5.0266 4.48244H9.62805Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_17297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.1818,
    fill: "white",
    transform: "translate(0.5 0.40918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/Wallet-icon.fe9465a17ea82a684751e78fcf0852a7.svg";
export { ForwardRef as ReactComponent };